import Vue from 'vue'

import * as types from '../mutation-types'

const state = {
  isShowingProjectOnEng: false
}

const getters = {
  getFromSession: (state) => (key) => {
    return state[key] !== undefined ? state[key] : null
  },
  isShowingProjectOnEng: (state) => {
    return state.isShowingProjectOnEng
  }
}

// actions
const actions = {
  addToSession ({ commit }, params) {
    commit(types.SESSION_ADD, params)
  },
  removeFromSession ({ commit }, key) {
    commit(types.SESSION_DEL, key)
  },
  setShowingProjectOnEng ({ commit }, value) {
    commit(types.IS_PROJ_ON_ENG, value)
  }

}

const mutations = {
  [types.SESSION_ADD] (state, params) {
    Vue.set(state, params.key, params.value)
  },
  [types.SESSION_DEL] (state, key) {
    delete state[key]
  },
  [types.RESET_ON_LOGOUT] (state) {
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
  },
  [types.IS_PROJ_ON_ENG] (state, value) {
    state.isShowingProjectOnEng = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
